// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__qPZPG","main":"Button_main__AV1BM","secondary":"Button_secondary__bkDOe"};